<template>
  <el-dialog
    class="VerCodeDialog"
    :title="dialogTitle"
    width="420px"
    :visible="visible"
    :modal-append-to-body="false"
    :before-close="() => (visible = false)"
    @closed="handleClosed"
  >
    <template v-if="captchaMode === 'slider'">
      <div class="slider-box">
        <div class="slider-stage">
          <img class="slider-bg" :src="getImageSrc(imgVer.background)" alt="" width="300" height="200" />
          <div class="slider-piece" :style="{ top: `${imgVer.y}px`, left: `${dragX}px` }">
            <img class="slider-piece-img" :src="getImageSrc(imgVer.slider)" alt="" />
          </div>
        </div>
        <div class="slider-track" ref="trackRef">
          <div class="slider-track-fill" :style="{ width: `${dragX + knobSize / 2}px` }"></div>
          <div
            class="slider-knob"
            :class="{ dragging: dragging }"
            :style="{ left: `${dragX}px` }"
            @mousedown.prevent="startDrag"
            @touchstart.prevent="startDrag"
          >
            <i class="el-icon-d-arrow-right"></i>
          </div>
        </div>
        <div class="slider-tip">拖动滑块完成验证</div>
      </div>
    </template>

    <template v-else>
      <div class="content-center">
        <img id="verImg" :src="getImageSrc(imgVer.codeImg)" width="194px" height="70px" />
      </div>
      <div class="content-center-column">
        <div class="content-center">
          <div>
            <el-input class="input-code" v-model="imgVer.verifyCode" placeholder="输入验证码"></el-input>
          </div>
          <el-button class="content-center input-right" @click="refreshVrcode"><i class="el-icon-refresh"></i></el-button>
        </div>
        <el-button type="primary" :loading="submiting" class="content-center submit-btn" :style="imgVer.verifyCode ? 'opacity: 1' : 'opacity: 0.5'" @click="enterCode">
          <span v-if="!submiting">提交验证</span>
          <span v-else>请稍后...</span>
        </el-button>
        <div style="height: 30px">
          <div style="line-height: 30px; color: red">{{ errorCode }}</div>
        </div>
      </div>
    </template>
    <div v-if="captchaMode === 'slider'" class="slider-footer">
      <div class="slider-footer-actions">
        <el-button class="refresh-btn" @click="refreshVrcode"><i class="el-icon-refresh"></i></el-button>
        <el-button type="primary" :loading="submiting" class="submit-btn slider-submit" @click="enterCode">
          <span v-if="!submiting">提交验证</span>
          <span v-else>请稍后...</span>
        </el-button>
      </div>
      <div class="error-text">{{ errorCode }}</div>
    </div>
  </el-dialog>
</template>

<script>
import { common } from '@/api/index'
import { tryCatch } from '@/utils/util'

export default {
  name: 'VerCodeDialog',
  data() {
    return {
      visible: false,
      localResolve: null,
      submiting: false,
      errorCode: '',
      phoneNumber: '',
      captchaMode: 'image',
      dragX: 0,
      knobSize: 42,
      dragging: false,
      trackWidth: 0,
      imgVer: {
        codeImg: '',
        key: '',
        verifyCode: '',
        background: '',
        slider: '',
        y: 0
      },
      firstType: ''
    }
  },
  computed: {
    dialogTitle() {
      return this.captchaMode === 'slider' ? '滑块验证' : '输入验证码'
    }
  },
  methods: {
    getImageSrc(image) {
      if (!image) return ''
      return /^data:image\/|^data:/.test(image) ? image : `data:image/png;base64,${image}`
    },
    resetSlider() {
      this.dragX = 0
      this.dragging = false
      this.trackWidth = 0
      this.removeDragListeners()
    },
    setCaptchaData(data = {}) {
      const { background, slider, y, image, key } = data
      this.errorCode = ''
      this.imgVer.key = key || ''
      this.imgVer.verifyCode = ''
      if (background && slider) {
        this.captchaMode = 'slider'
        this.imgVer.background = background
        this.imgVer.slider = slider
        this.imgVer.y = Number(y || 0)
        this.imgVer.codeImg = ''
        this.resetSlider()
      } else {
        this.captchaMode = 'image'
        this.imgVer.codeImg = image || ''
        this.imgVer.background = ''
        this.imgVer.slider = ''
        this.imgVer.y = 0
      }
    },
    open(phoneNumber, type, captchaData) {
      this.phoneNumber = phoneNumber
      this.firstType = type
      return new Promise(resolve => {
        this.localResolve = resolve
        if (captchaData) {
          this.setCaptchaData(captchaData)
        } else {
          this.refreshVrcode()
        }
        this.$nextTick(() => {
          this.visible = true
        })
      })
    },
    // 刷新验证码
    async refreshVrcode() {
      let res = await common.getVrcode()
      if (!res?.data?.success) return this.$message({ message: res.msg, type: "error" });
      this.setCaptchaData(res.data.data || {})
      this.visible = true
    },

    updateTrackWidth() {
      if (!this.$refs.trackRef) return
      this.trackWidth = this.$refs.trackRef.getBoundingClientRect().width || 0
    },

    startDrag() {
      this.updateTrackWidth()
      this.dragging = true
      this.bindDragListeners()
    },

    bindDragListeners() {
      this.removeDragListeners()
      window.addEventListener('mousemove', this.handleDragMove)
      window.addEventListener('mouseup', this.stopDrag)
      window.addEventListener('touchmove', this.handleDragMove, { passive: false })
      window.addEventListener('touchend', this.stopDrag)
    },

    removeDragListeners() {
      window.removeEventListener('mousemove', this.handleDragMove)
      window.removeEventListener('mouseup', this.stopDrag)
      window.removeEventListener('touchmove', this.handleDragMove)
      window.removeEventListener('touchend', this.stopDrag)
    },

    handleDragMove(e) {
      if (!this.dragging || !this.trackWidth) return
      if (e.cancelable) e.preventDefault()
      const maxX = Math.max(this.trackWidth - this.knobSize, 0)
      const rect = this.$refs.trackRef.getBoundingClientRect()
      const clientX = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX)
      const nextX = clientX - rect.left - this.knobSize / 2
      this.dragX = Math.max(0, Math.min(nextX, maxX))
    },

    stopDrag() {
      this.dragging = false
      this.removeDragListeners()
    },

    // 提交验证码
    async enterCode() {
      let { phoneNumber, imgVer, firstType } = this
      let { key, verifyCode } = imgVer
      if (this.captchaMode === 'image' && verifyCode === '') {
        this.errorCode = '请输入验证码'
        return
      }
      this.submiting = true
      let [err, res] = await tryCatch(common.verifySms, {
        key,
        verifyCode: this.captchaMode === 'slider' ? String(Math.round(this.dragX)) : verifyCode,
        phoneNumber,
        type: firstType
      })
      this.submiting = false
      if (err || !res?.data?.success) {
        this.errorCode = err?.msg || res?.data?.msg || '验证失败，请重试'
        return
      }
      res?.data?.success ? (this.visible = false) : (this.errorCode = res?.data?.msg)
      this.$emit('startTime')
      this.localResolve('success')
    },

    // 关闭
    handleClosed() {
      this.stopDrag()
      this.localResolve && this.localResolve('close')
      Object.assign(this.$data, this.$options.data())
    }
  },
  mounted() {
    if (this.captchaMode === 'slider') this.updateTrackWidth()
  }
}
</script>

<style lang="less" scoped>
.VerCodeDialog {
  /deep/ .el-dialog {
    margin-top: 40vh !important;
    .el-dialog__header {
      padding: 16px 24px;
      border-bottom: 1px solid #f5f5f5;
    }
    .el-dialog__body {
      padding: 0 0 24px 0;
    }

    .submit-btn {
      width: 220px;
      background: rgba(17, 112, 235);
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-top: 16px;
      border: none;
    }
  }
  .slider-box {
    padding: 4px 24px 20px;
  }
  .slider-stage {
    position: relative;
    width: 300px;
    height: 200px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 8px;
    background: #f5f7fa;
  }
  .slider-bg {
    display: block;
    width: 300px;
    height: 200px;
  }
  .slider-piece {
    position: absolute;
    width: 40px;
    height: 40px;
    overflow: hidden;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    background: rgba(255, 255, 255, 0.95);
  }
  .slider-piece-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .slider-track {
    position: relative;
    width: 300px;
    height: 36px;
    margin-top: 16px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 18px;
    background: #eef2f7;
    overflow: hidden;
    user-select: none;
  }
  .slider-track-fill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: rgba(17, 112, 235, 0.16);
  }
  .slider-knob {
    position: absolute;
    top: 2px;
    width: 42px;
    height: 32px;
    border-radius: 16px;
    background: #1170eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
    transition: box-shadow 0.15s ease;
  }
  .slider-knob.dragging {
    cursor: grabbing;
    box-shadow: 0 4px 14px rgba(17, 112, 235, 0.35);
  }
  .slider-tip {
    margin-top: 10px;
    font-size: 12px;
    color: #888;
    text-align: center;
  }
  .slider-footer {
    width: 300px;
    margin: 16px auto 0;
  }
  .slider-footer-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }
  .refresh-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    background: #ffffff;
    border: 1px solid #d8e2f0;
    border-radius: 4px;
    color: #4a90ff;
  }
  .slider-submit {
    width: 206px;
    margin-top: 0 !important;
  }
  .error-text {
    min-height: 24px;
    margin-top: 10px;
    line-height: 24px;
    color: red;
    font-size: 12px;
    text-align: center;
  }
  .input-right {
    width: 32px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dddddd;
  }

  .input-code {
    /deep/ .el-input__inner {
      line-height: 32px;
      width: 160px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #dddddd;
      margin-right: 9px;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #bfbfbf;
      line-height: 20px;
    }
  }
}
</style>
